// extracted by mini-css-extract-plugin
export default {"overlay":"W0lNOKrV+8mvx5zJb3TX2w==","overlayDashboardView":"-2vtjvQe928a4o6Ezb8hYg=="};